import { Link } from "@remix-run/react";

import { useOptionalUser } from "~/utils";
import { ReconizerLogo } from "~/ui/logo/ReconizerLogo";
import { useTranslation } from "react-i18next";

export default function Index() {
  const user = useOptionalUser();
  const { t } = useTranslation();

  return (
    <main className="relative min-h-screen sm:flex sm:items-center sm:justify-center">
      <div className="relative sm:pb-16 sm:pt-8">
        <div className="pb-16">
          <ReconizerLogo />
        </div>
        <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="relative flex justify-center sm:overflow-hidden">
            {user ? (
              <Link
                to="/dashboard"
                className="flex items-center justify-center bg-primary px-4 py-3 text-base font-medium text-white shadow-sm sm:px-8"
              >
                {t("app.link.dashboard")}
              </Link>
            ) : (
              <div className="flex gap-4">
                <Link to="/login" className="bg-primary px-4 py-3 font-medium text-white">
                  {t("app.login")}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
